import {
  EFilesActionTypes,
  TFilesUploadPayload,
  TFilesUploadPendingPayload,
  TFilesUploadSucceedPayload,
} from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const uploadFilesPending = actionGenerator<EFilesActionTypes.UploadPending, TFilesUploadPendingPayload>(
  EFilesActionTypes.UploadPending,
);

export const uploadFilesSucceed = actionGenerator<EFilesActionTypes.UploadSucceed, TFilesUploadSucceedPayload>(
  EFilesActionTypes.UploadSucceed,
);

export const uploadFilesFailed = actionGenerator<EFilesActionTypes.UploadFailed, TFilesUploadPayload>(
  EFilesActionTypes.UploadFailed,
);

export const setWsSendSucceed = actionGenerator<EFilesActionTypes.WsSendSucceed, TFilesUploadPayload>(
  EFilesActionTypes.WsSendSucceed,
);
